import React, { useState, useEffect } from "react";
import axios from "axios";
import { ItemRequisitionAPI } from "../ItemRequisitionAPI";
import { UserConsumer } from "../../../UserContext";
import paginationFactory, {
	PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { Table } from "../../../components/CustomPaginations";
import { dateCol } from "../../ticketModule/variables/ListingVariables";
import { tableStyle, TrimString } from "../../../components/TableStyle";
import { AlertPopups } from "../../../components/AlertPopups";
import ActionFormatter from "./ActionFormatter";

function VendorQuotationsFormList(props) {
	const { itemRequisitionId, setIsVendorLoaded } = props;
	let token = null;
	const defaultSorted = [
		{
			dataField: "vendor",
			order: "asc",
		},
	];
	const [tableData, setTableData] = useState(null);
	const [pagerData, setPagerData] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const [pageNum, setPageNum] = useState(1);
	const [sortBy, setSortBy] = useState(defaultSorted[0]);
	const [numberOfItemsPerPage, setNumberOfItemsPerPage] = useState(10);

	const customFormatter = (row) => (
		<ActionFormatter
			rowData={row}
			editFunction={() => props.editVendorQuotations(row)}
			id={row.id}
			deleteFunction={() => deleteVendorQuotation(row.quotationId)}
		/>
	);

	const getColumns = [
		{
			dataField: "vendor",
			text: "Name",
			sort: true,
			 title: true ,
			headerStyle: {
				width: "15%",
			},
			formatter: TrimString,
		},
		{
			dataField: "unitPrice",
			text: "Unit Price",
			sort: true,
		},
		{
			dataField: "quantity",
			text: "Quantity",
			sort: true,
		},
		{
			dataField: "totalAmount",
			text: "Total Cost",
			sort: true,
		},
		{
			dataField: "description",
			text: "Description",
			 title: true ,
			sort: true,
			headerStyle: {
				width: "15%",
			},
		},
		{
			dataField: "recommended",
			text: "Recommended",
			formatter: (cell, row) => {
				return row.recommended === true ? "Yes" : "No";
			},
			sort: true,
		},
		{
			dataField: "deliveryTime",
			text: "Delivery Time",
			sort: true,
			formatter: dateCol,
		},
		{
			dataField: "edit",
			text: "Edit",
			formatter: (cell, row) => customFormatter(row),
		},
	];

	useEffect(() => {
		getAllVendorQuotations();
	}, []);
	const getAllVendorQuotations = () => {
		axios
			.get(
				`${ItemRequisitionAPI.GetVendorQuotationsList}/${itemRequisitionId}/VendorQuotations?PageSize=${numberOfItemsPerPage}&PageNumber=${pageNum}&sortBy=${sortBy.dataField}_${sortBy.order}`,
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setTableData(res.data.quotations);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setIsVendorLoaded(true);
				}
			});
	};
	const deleteVendorQuotation = (id) => {
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		AlertPopups.confirmBox
			.fire({
				text: AlertPopups.confirmMsg,
			})
			.then((result) => {
				if (result.value) {
					setIsLoading(true);
					axios
						.delete(
							`${ItemRequisitionAPI.DeleteVendorQuotation}/${itemRequisitionId}/VendorQuotations/${id}`,
							{
								headers: headers,
							}
						)
						.then((res) => {
							if (res.status === 200) {
								AlertPopups.InfoAlert.fire({
									text: "Vendor Removed",
								});
								getAllVendorQuotations();
							}
						});
				}
			});
	};
	const handleTableChange = (type, { page, sortOrder, sortField }) => {
		setIsLoading(true);
		let getData = false;
		let apiURL = "";

		if (type === "sort") {
			apiURL = `${ItemRequisitionAPI.GetVendorQuotationsList}/${itemRequisitionId}/VendorQuotations?PageSize=${numberOfItemsPerPage}&PageNumber=${page}&sortBy=${sortField}_${sortOrder}`;
			setSortBy({ dataField: sortField, order: sortOrder });
			getData = true;
		} else if (type === "pagination") {
			apiURL = `${ItemRequisitionAPI.GetVendorQuotationsList}/${itemRequisitionId}/VendorQuotations?PageSize=${numberOfItemsPerPage}&PageNumber=${page}&sortBy=${sortBy.dataField}_${sortBy.order}`;
			getData = true;
		}
		if (getData) {
			axios
				.get(apiURL, {
					headers: {
						Authorization: `Bearer ${token}`,
					},
				})
				.then((res) => {
					if (res.status === 200) {
						setIsLoading(false);
						setPageNum(page);
						setTableData(res.data.quotations);
						setPagerData(JSON.parse(res.headers["x-pagination"]));
					}
				});
		}
	};
	const receiveData = (PageSize) => {
		setIsLoading(true);
		let apiURL = `${
			ItemRequisitionAPI.GetVendorQuotationsList
		}/${itemRequisitionId}/VendorQuotations?PageSize=${PageSize}&PageNumber=${1}&sortBy=${
			sortBy.dataField
		}_${sortBy.order}`;
		axios
			.get(apiURL, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPageNum(1);
					setNumberOfItemsPerPage(PageSize);
					setTableData(res.data.quotations);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
				}
			});
	};
	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				return (
					<div className="formTableList">
						{tableData ? (
							<PaginationProvider
								pagination={paginationFactory({
									custom: true,
									totalSize: pagerData
										? pagerData.TotalCount
										: 0,
									page: pageNum,
									sizePerPage: numberOfItemsPerPage,
									paginationSize: numberOfItemsPerPage,
								})}
							>
								{({
									paginationProps,
									paginationTableProps,
								}) => {
									return (
										<Table
											keyField={"token"}
											columns={getColumns}
											items={tableData}
											headerClass={"sub-thead"}
											tableStyle={tableStyle}
											bodyClasses="formList"
											paginationProps={paginationProps}
											paginationTableProps={
												paginationTableProps
											}
											onTablePageChange={
												handleTableChange
											}
											defaultSorted={defaultSorted}
											showFeedback={true}
											tableLoader={isLoading}
											SearchBar={() => {
												return null;
											}}
											pagerData={pagerData}
											receiveData={(PageSize) => {
												receiveData(PageSize);
											}}
										/>
									);
								}}
							</PaginationProvider>
						) : null}
					</div>
				);
			}}
		</UserConsumer>
	);
}

export default VendorQuotationsFormList;
